import styled, { css } from 'styled-components';
import { Link } from 'gatsby';
import { underlineTransition } from '@components/link/link.styled';

interface StyledLinkProps {
  $isActive: boolean;
}

export const StyledLink = styled(Link)<StyledLinkProps>`
  ${({ theme, $isActive = false }) => css`
    ${underlineTransition}
    text-decoration: none;
    pointer-events: ${$isActive ? 'none' : 'auto'};
    font-family: ${theme.fontFamily.display};
    font-size: 1.125rem;
    font-weight: 500;
    margin-bottom: 1rem;
  `}
`;

export const StyledExternalLink = styled.a`
  ${({ theme }) => css`
    ${underlineTransition}
    text-decoration: none;
    color: ${theme.colors.black};
    font-family: ${theme.fontFamily.display};
    font-size: 1.125rem;
    font-weight: 500;
    margin: 0 ${theme.spacing.xs};
    padding: ${theme.spacing.xs};
    padding-left: 0;
    margin-left: 0;
    margin-bottom: 1rem;
    display: block;

    :hover {
      text-decoration: underline;
    }

    :last-child {
      padding-right: 0;
      margin-right: 0;
    }
  `}
`;

export const StyledBorderedLink = styled(StyledLink)`
  ${({ theme }) => css`
    display: none;
    align-items: center;
    padding: 0 0.75rem;
    height: 2rem;
    border: ${theme.borderWidths.icons} solid ${theme.colors.accent};
    color: ${theme.colors.primary} !important;
    background-color: ${theme.colors.accent};
    border-radius: 1.25rem;
    font-weight: 500;
    font-family: ${theme.fontFamily.display};
    font-size: 0.9375rem;
    background-image: none;

    :hover {
      background-color: ${theme.colors.primary};
      border-color: ${theme.colors.primary};
      color: ${theme.colors.white} !important;
      text-decoration: none;
    }
  `}
`;

export const LinkContainer = styled.div`
  position: relative;
  margin-right: 1.25rem;
`;

export const LinkItem = styled.li`
  ${({ theme }) => css`
    ${StyledLink}, ${StyledBorderedLink} {
      color: ${theme.colors.black};
    }
  `}
`;
